import { Logger } from '@nestjs/common';
import { NestFactory } from '@nestjs/core';
import { SwaggerModule, DocumentBuilder } from '@nestjs/swagger';
import { AppModule } from './app/app.module';
import * as bodyParser from 'body-parser';
import { ValidationPipe } from '@nestjs/common';
import * as nodemailer from 'nodemailer';
import { CommonResponseModel } from '@project-management-system/shared-models';
async function bootstrap() {
  const app = await NestFactory.create(AppModule, { logger: ['error'] });
  app.useGlobalPipes(new ValidationPipe({
    whitelist: true,
  }));
  const globalPrefix = 'api';
  app.setGlobalPrefix(globalPrefix);
  const port = Number(9002);

  const options = new DocumentBuilder()
    .setTitle('Migration System')
    .setDescription('')
    .setVersion('0.0')
    // .setBasePath(`${ptsConfigs.swagger.basePath}`)
    .addBearerAuth()
    .addTag('ms')
    .build();

  const document = SwaggerModule.createDocument(app, options);
  SwaggerModule.setup(`api`, app, document);
  app.use(bodyParser.json({ limit: '10mb' }));
  app.use(bodyParser.urlencoded({ limit: '10mb', extended: true }));
  app.enableCors();
  await app.listen(port);
  console.log(
    `🚀 Application is running on: http://localhost:${port}/${globalPrefix}`
  );
  // process.on('uncaughtException', async (error) => {
  //   console.log(error, "UNCAUGHT EXCEPTION")
  
  //   const recipientEmail = 'jaswanthpappala3@gmail.com';
  //   const ccEmails = ['saiprakash.katiki@gmail.com', 'santhosh.palaksha@shahi.co.in', 'manu.gupta@shahi.co.in', 'pradeep@schemaxtech.com', 'sujatha@schemaxtech.com'];
  //   const errorMessage = "Service Was stopped in RL Please check"

  //     const transporter = nodemailer.createTransport({
  //       host: 'smtp.gmail.com',
  //       port: 587,
  //       secure: false,
  //       auth: {
  //         user: 'jayanthpappala3@gmail.com',
  //         pass: 'pohe kref wtua gijk'
  //       }
  //     });

  //     const mailOptions = {
  //       from: 'jayanthpappala3@gmail.com',
  //       to: recipientEmail,
  //       cc: ccEmails,
  //       subject: 'Notification: Service Stopped In RL',
  //       html: `Dear User,<br><br>${errorMessage}.<br><br>Regards,<br><strong style="color: black;">Service Stopped BOT</strong>`,
  //     };

  //     await transporter.sendMail(mailOptions);
  //     return new CommonResponseModel(true, 1, "Notification Sent Successfully");
  // })
}

bootstrap();